import { combineReducers, Reducer } from "redux";
import { UserReducer, UserState } from "./User";
import { UserDataReducer, UserDataState } from "./UserData";
import { connectRouter, RouterState } from "connected-react-router";
import { TempDataReducer, TempDataState } from "./TempData";
import { EjariDataReducer, EjariDataState } from "@eres/ejari-core/reducers/EjariData";
import { EjariContractDataReducer } from "@eres/ejari-core/reducers/EjariContractData";
import { TenantContractDataReducer } from "@eres/ejari-core/reducers/TenantContractData";
import { TenantDataReducer } from "@eres/ejari-core/reducers/TenantData";
import { LeasedDataReducer } from "@eres/ejari-core/reducers/LeasedData";
import { VaultReducer } from "@eres/dldvault/VaultReducer";
import { FGReducer } from "@10x/feature-gate";
import { ManagementContractDataReducer } from "@eres/ejari-core/reducers/ManagementContractData";

const appReducer = ( history: any, reducers: { [ k: string ]: Reducer } ) => combineReducers( {
	router: connectRouter( history ),
	User: UserReducer,
	UserData: UserDataReducer,
	TempData: TempDataReducer,
	EjariData: EjariDataReducer,
	EjariContractData: EjariContractDataReducer,
	ManagementContractData: ManagementContractDataReducer,
	TenantData: TenantDataReducer,
	TenantContractData: TenantContractDataReducer,
	LeasedData: LeasedDataReducer,
	Vault: VaultReducer,
	FeatureGate: FGReducer,
	...reducers
} );
export type RootState = ReturnType<ReturnType<typeof appReducer>>;
export default appReducer;
declare module "@10x/coreapp" {

	interface AppReducer {
		User: UserState,
		TempData: TempDataState,
		router: RouterState,
		UserData: UserDataState,
		EjariData: EjariDataState,
	}
}
